/**
 * Secure Mode Banner Component
 *
 * Displays banner indicating secure mode status (OFF/ON)
 */

import { InfoIcon, SuccessIcon } from './Icon';
import styles from './SecureModeBanner.module.css';

interface SecureModeBannerProps {
  mode: 'off' | 'on';
  callCode?: string;
}

export const SecureModeBanner = ({ mode, callCode }: SecureModeBannerProps) => {
  if (mode === 'off') {
    if (!callCode) {
      return (
        <div className={styles.secureModeOffBanner}>
          <div className={styles.bannerIconSection}>
            <InfoIcon className={styles.bannerIcon} size={24} />
          </div>
          <div className={styles.bannerContent}>
            <div className={styles.bannerTitle}>Preparing secure session…</div>
            <div className={styles.bannerText}>
              Please wait while we generate your call code.
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.secureModeOffBanner}>
        <div className={styles.bannerIconSection}>
          <InfoIcon className={styles.bannerIcon} size={24} />
        </div>
        <div className={styles.bannerContent}>
          <div className={styles.bannerTitle}>Secure mode is OFF</div>
          <div className={styles.bannerText}>
            Enter the <strong>call code</strong> in your phone to enable Secure
            Mode and continue with the payment.
          </div>
          <div className={styles.bannerCallCode}>
            Call code:{' '}
            <strong>
              {callCode.startsWith('*#') ? callCode : `*#${callCode}`}
            </strong>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.secureModeOnBanner}>
      <div className={styles.bannerIconSection}>
        <SuccessIcon className={styles.bannerIcon} size={24} />
      </div>
      <div className={styles.bannerContent}>
        <div className={styles.bannerTitle}>Secure mode is ON!</div>
        <div className={styles.bannerText}>
          You can now proceed with this payment. Only the customer is able to
          enter data into the sensitive fields.
        </div>
      </div>
    </div>
  );
};
